import { cn } from "@/lib/utils";
import { Badge } from "@/modules/shadcn/ui/badge";
import { useTranslation } from "react-i18next";

/**
 * Marks a label that has been archived. Old models and test cases keep
 * listing such a label; this is what tells the reader it is no longer a live
 * class of the project.
 */
export const ArchivedBadge = ({ className }: { className?: string }) => {
  const { t } = useTranslation("common");
  return (
    <Badge
      variant="outline"
      title={t("archived.hint")}
      className={cn(
        "h-4 px-1.5 text-[10px] font-normal text-muted-foreground",
        className,
      )}
    >
      {t("archived.badge")}
    </Badge>
  );
};
